import ENUM_LIST_WITH_PATTERN from './enumListWithPattern.graphql'

export { ENUM_LIST_WITH_PATTERN }
